import { MILLISECONDS_PER_SECOND, SECONDS_PER_MINUTE } from 'constants/date';

import { ZERO_PAD_LENGTH } from './constants';

const padZero = num => String(num).padStart(ZERO_PAD_LENGTH, '0');

export const formatElapsedTime = startTime => {
  const elapsedMs = Date.now() - new Date(startTime).getTime();
  const totalSeconds = Math.max(0, Math.floor(elapsedMs / MILLISECONDS_PER_SECOND));
  const minutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE);
  const seconds = totalSeconds % SECONDS_PER_MINUTE;

  return `${minutes}m ${padZero(seconds)}s`;
};
